module.exports = __webpack_public_path__ + "img/user.2f7d85cb.svg";